<template>
    <div class="offcanvas offcanvas-end offcanvas-01" id="offcanvasCreate" tabindex="-1"
        aria-labelledby="offcanvasCreateLabel">
        <div class="offcanvas-header">
            <h5 class="text-dark" id="offcanvasCreateLabel">{{ mode }} Investor Relation</h5>
            <button class="btn btn-danger btn-sm" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                ref="btnClose">
                <i class="ic-close"></i>
            </button>
        </div>
        <div class="offcanvas-body">
            <div class="row">
                <form class="row align-end" v-on:submit.prevent="submitForm" enctype="multipart/form-data">

                    <div class="col-md-12 mb-16">
                        <label for="">Title</label>
                        <input type="text" class="form-control" :class="{ 'border-red': errors.title }"
                            v-model="item.title" />
                        <ErrorSpan :error="errors.title" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <div class="col-md-6 ">
                            <label for="">File</label>
                            <UploadedFile :file='storage + item.file' :clearUploadedFile="clearUploadedFile"
                                v-if="mode === 'Edit' && item.file" />
                            <input type="file" class="form-control" ref="file" @input="handleFileUpload" v-else />
                        </div>
                        <ErrorSpan :error="errors.file" />
                    </div>


                    <div class="col-md-6 mb-16">
                        <label for="">Parents</label>
                        <select name="parent_id" class="form-select"
                            :class="{ 'border-red': errors.parent_id }" v-model="item.parent_id">
                            <option value="" disabled selected>Select Parent</option>
                            <option v-for="item in parents" :key="item.id" :value="item.id">{{ item.title }}</option>
                        </select>
                        <ErrorSpan :error="errors.category_id" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Display Order</label>
                        <input type="number" min="1" @input="item.order_by = item.order_by < 1 ? '' : item.order_by"
                            class="form-control" :class="{ 'border-red': errors.order_by }" v-model="item.order_by" />
                        <ErrorSpan :error="errors.order_by" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" true-value="1" false-value="0"
                                v-model="item.status" />
                            <label class="form-check-label" for="flexSwitchCheckDefault">Status</label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button type="button" aria-label="Close" @click="closeForm" class="btn btn-red mr-16">
                            <i class="ic-close mr-8"></i>Cancel
                        </button>
                        <button v-if="!isLoading" class="btn btn-green" type="submit">
                            <i class="ic-checkmark mr-8"></i>Save
                        </button>
                        <button v-else class="btn btn-green" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CreateMixin from "@/mixins/create.vue"
import UploadPreviewMixin from "@/mixins/uploadpreview.vue";
import UploadedFile from "@/components/Utility/UploadedFile.vue";
import ErrorSpan from "@/components/errorspan.vue";
import MediasMixin from "@/mixins/MediasMixin.vue";

export default {
    name: "InvestorRelationModal",
    components: {
        UploadedFile,
        ErrorSpan
    },
    mixins: [CreateMixin, UploadPreviewMixin, MediasMixin],
    data() {
        return {
            url: 'investor-relation',
            fetch_module: 'FETCH_INVESTOR_RELATION',
            parents: [],
        };
    },

    mounted() {
        
        this.$root.$on('CREATE', () => {
            this.item = {};
            this.isEdit = false;
            this.mode = "Add";
            this.errors = {};
            this.fetchParents();
            this.clearselectedFiles();
        });

        this.$root.$on('EDIT', (data) => {
            this.errors = {};
            this.isEdit = true;
            this.item = { ...data };
            this.mode = "Edit";
            this.fetchParents();
            this.clearselectedFiles();
        });

    },
    methods: {
        closeForm() {
            this.$refs.btnClose.click();
        },
        fetchParents()
        {
            this.axios.get(process.env.VUE_APP_API_URL + this.url + '/parents').then(({ data }) => {
            this.parents = data.data;
        });
        }
    },
};
</script>

<style scoped>

</style>
